module.exports = __webpack_public_path__ + "static/media/all-video-eclipse.480ec3fe.png";